import React from 'react'

import clsx from 'clsx'

import { IconButton } from 'components/Button'
import Icon from 'components/Icon'
import Link from 'components/Link'
import { FixedImage } from 'components/NextImage'
import Rating from 'components/Rating'
import Typography from 'components/Typography'
import { useEventContext } from 'context/EventContext'
import { getengagementDestination } from 'helpers/reviews'

import classes from './SavedCard.module.scss'

/** @type {import("./types").default} */
const SavedCard = ({ className, listing, onClick }) => {
  const { addEvent } = useEventContext({
    engagementComponent: 'product_card-item_user-profile',
    name: 'engagement_product_click',
    productClickUUID: listing.global_product_id,
  })

  return (
    <div className={clsx('SavedCard', classes.root, className)}>
      <a
        className={classes.fixedImageContainer}
        href={listing.cta_urls.detail}
        {...addEvent({
          engagementDestination: 'go-to_product_details',
          engagementDetails: 'logo_product',
        })}
      >
        <FixedImage width={48} src={listing.logo_url} alt={listing.name} />
      </a>
      <div className={classes.body}>
        <div className={classes.header}>
          <div>
            <Link
              className={classes.name}
              href={listing.cta_urls.detail}
              variant="heading-sm"
              {...addEvent({
                engagementDestination: 'go-to_product_details',
                engagementDetails: 'text-link_product-name',
              })}
            >
              {listing.name}
            </Link>
            <Rating.Link
              average={listing.rating_avg}
              href={listing.cta_urls.reviews}
              isCompact
              totals={listing.num_reviews}
              {...addEvent({
                engagementDestination: getengagementDestination(listing.cta_urls.reviews),
                engagementDetails: 'data_overall-rating_stars',
              })}
            />
          </div>
          <IconButton
            className={classes.iconButton}
            onClick={onClick}
            {...addEvent({
              engagementDestination: 'user-profile_remove-product',
              engagementDetails: 'icon_remove',
            })}
          >
            <Icon className={classes.icon} icon={['far', 'trash-can']} size={16} />
          </IconButton>
        </div>
        <Typography className={classes.tagline} variant="tight-xxs">
          {listing.tagline}
        </Typography>
      </div>
    </div>
  )
}

export default SavedCard
